import script from "./Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Result.vue?vue&type=script&setup=true&lang=js"

import "./Result.vue?vue&type=style&index=0&id=344c1d40&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344c1d40"]])

export default __exports__